export default import.meta.ROLLDOWN_FILE_URL_n9D8sixoynFJNDKs__WYCw